// src/stores/warehouseStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface WarehouseStore {
  selectedWarehouseId: string;
  selectedWarehouseName: string;
  selectedWarehouseGstin: string;
  selectedWarehouseState: string;
  setSelectedWarehouse: (id: string, name: string, gstin?: string, state?: string) => void;
}

export const useWarehouseStore = create<WarehouseStore>()(
  persist(
    (set) => ({
      selectedWarehouseId: '',
      selectedWarehouseName: '',
      selectedWarehouseGstin: '',
      selectedWarehouseState: '',
      setSelectedWarehouse: (id, name, gstin = '', state = '') =>
        set({
          selectedWarehouseId: id,
          selectedWarehouseName: name,
          selectedWarehouseGstin: gstin,
          selectedWarehouseState: state,
        }),
    }),
    { name: 'selected-warehouse' }
  )
);